import { useState } from 'react'
import type { FormDataType } from './types'

const INITIAL_FORM_DATA: FormDataType = {
    companyName: '',
    contactName: '',
    phoneNumber: '',
    email: '',
    inquiryContent: '',
    consent: false,
}

export function useForm() {
    const [formData, setFormData] = useState<FormDataType>(INITIAL_FORM_DATA)
    const [isSubmitting, setIsSubmitting] = useState(false)

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const { name, value, type } = e.target
        const checked = (e.target as HTMLInputElement).checked

        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }))
    }

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        setIsSubmitting(true)

        try {
            const csrfToken = document.querySelector<HTMLMetaElement>(
                'meta[name="csrf-token"]'
            )?.content
            const inquiryUrl = '/business/ft_business/inquiry'

            const response = await fetch(inquiryUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': csrfToken || '',
                },
                body: JSON.stringify({
                    company_name: formData.companyName,
                    contact_name: formData.contactName,
                    phone_number: formData.phoneNumber,
                    email: formData.email,
                    inquiry_content: formData.inquiryContent,
                    consent: formData.consent,
                    is_hotel: false,
                    is_foodstadium: true,
                }),
            })

            const data = await response.json().catch(() => ({}))

            if (response.ok && data.success && data.redirect_url) {
                window.location.href = data.redirect_url
                return
            }

            if (response.ok) {
                setFormData(INITIAL_FORM_DATA)
                alert('お問い合わせを受け付けました。')
            } else {
                alert(
                    data.errors?.join('\n') ||
                        'エラーが発生しました。もう一度お試しください。'
                )
            }
        } catch (error) {
            console.error('Error submitting form:', error)
            alert('エラーが発生しました。もう一度お試しください。')
        } finally {
            setIsSubmitting(false)
        }
    }

    return { formData, isSubmitting, handleChange, handleSubmit }
}
